/**
 * Training form fields the assistant is able to pre-fill from a program.
 * Same wire values as the SDK's `AiCompanionTrainingFieldEnum` (the `reviewTraining` payload).
 */
export enum TrainingPrefillFieldEnum {
  TRAINING_PARTNER = "training_partner",
  TITLE = "title",
  EXTERNAL_URL = "external_url",
  DURATION_HOURS = "duration_hours",
  DURATION_DAYS = "duration_days",
  TARGET_AUDIENCE = "target_audience",
  GOALS = "goals",
  PROGRAM = "program",
  FORMAT = "format",
  PRICE_INTER_EXCL_TAX = "price_inter_excl_tax",
  PRICE_INTRA_EXCL_TAX = "price_intra_excl_tax",
}
